import { Divider, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const WidgetHeader = ({
  onRemove,
  title,
}: {
  onRemove: () => void;
  title: string;
}) => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        data-testid="widget-header"
        className="widget-header"
        pl={2.25}
        pr={1.5}
        py={1.1}
      >
        <Typography variant="body1" fontWeight={500} className="widget-title">
          {title}
        </Typography>
        <div className="widget-controls">
          <IconButton
            size="small"
            data-testid="remove-widget"
            className="close"
            onClick={onRemove}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
      </Stack>
      <Divider />
    </>
  );
};

export default WidgetHeader;
